import React from "react";

import { Switch, TextField, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";

import dayjs from "dayjs";

import { PublishingRuleCreateSchema } from "../../types";
import AddButton from "../AddButton";
import DateField from "../DateField";
import RemoveButton from "../RemoveButton";

export interface ExcludedDaysSectionProps {
  schedule: PublishingRuleCreateSchema;
  setSchedule: React.Dispatch<React.SetStateAction<PublishingRuleCreateSchema>>;
}

const ExcludedDaysSection: React.FC<ExcludedDaysSectionProps> = ({
  schedule,
  setSchedule,
}) => {
  const handleAddExcludedDate = () => {
    setSchedule((prev: PublishingRuleCreateSchema) => ({
      ...prev,
      days_exceptions: [...prev.days_exceptions, { day_name: "", date: "" }],
    }));
  };

  const handleRemoveExcludedDate = (index: number) => {
    setSchedule((prev: PublishingRuleCreateSchema) => ({
      ...prev,
      days_exceptions: prev.days_exceptions.filter((_, i) => i !== index),
    }));
  };

  return (
    <Box>
      <Stack
        alignItems="center"
        direction="row"
        justifyContent="space-between"
        mb={2}
      >
        <Typography variant="subtitle1">Exkluderade utgivningsdagar</Typography>
        <Switch
          checked={schedule.days_exceptions.length > 0}
          onChange={(e) => {
            if (!e.target.checked) {
              setSchedule((prev: PublishingRuleCreateSchema) => ({
                ...prev,
                days_exceptions: [],
              }));
            } else {
              handleAddExcludedDate();
            }
          }}
        />
      </Stack>
      <Typography gutterBottom color="text.secondary" variant="caption">
        Ange specifika dagar då utgivning inte sker, t.ex. midsommarafton
      </Typography>
      {schedule.days_exceptions.map((excludedDate, index) => (
        <Stack
          key={index}
          alignItems="center"
          direction="row"
          mt={2}
          spacing={2}
        >
          <TextField
            label="Namn"
            size="small"
            sx={{
              bgcolor: "white", // TODO Fix dark mode
            }}
            value={excludedDate.day_name}
            onChange={(e) =>
              setSchedule((prev: PublishingRuleCreateSchema) => ({
                ...prev,
                days_exceptions: prev.days_exceptions.map((date, i) =>
                  i === index ? { ...date, day_name: e.target.value } : date,
                ),
              }))
            }
          />
          <DateField
            value={excludedDate.date ? dayjs(excludedDate.date) : null}
            onChange={(date) => {
              if (date) {
                setSchedule((prev: PublishingRuleCreateSchema) => ({
                  ...prev,
                  days_exceptions: prev.days_exceptions.map((d, i) =>
                    i === index ? { ...d, date: date.format("YYYY-MM-DD") } : d,
                  ),
                }));
              }
            }}
          />
          <RemoveButton onClick={() => handleRemoveExcludedDate(index)} />
        </Stack>
      ))}
      {schedule.days_exceptions.length > 0 && (
        <AddButton onClick={handleAddExcludedDate} />
      )}
    </Box>
  );
};

export default ExcludedDaysSection;
